import FormeJuridique from '@/generated/classes/FormeJuridique';
export default class FormeJuridiqueExtend extends FormeJuridique {
  constructor() {
    super();
  }
}
